export default "__VITE_ASSET__Dvshse5H__"